import './App.css';
import { BsFillMoonStarsFill } from 'react-icons/bs';
import { AiFillGithub, AiFillYoutube, AiFillTwitterCircle } from 'react-icons/ai';

function App() {
  return (
    <div >
      <head>
        <title>My Portfolio</title>
        <meta name="viewport" content="width=device-width, initial-scale=1.0"></meta>
      </head>
      <main className="bg-white px-10">
        <section className="bg-blend-lighten min-h-screen">
          <nav className='py-10 mb-12 flex justify-between'>
            <h1 className='text-2xl font-sans'>qiman</h1>

            <ul className='flex items-center'>
              <li>
                <BsFillMoonStarsFill className='cursor-pointer text-2xl' />
              </li>
              <li>
                <a className='bg-gradient-to-r from-cyan-500 to-teal-500 text-white px-4 py-2 rounded-lg ml-8' href="#">Resume</a>
              </li>
            </ul>
          </nav>
          <div className='text-center p-10'>
            <h2 className='text-5xl text-teal-500 font-semibold'>Qiman Wang</h2>
            <h3 className='text-2xl py-2'>Software Engineer</h3>
            <p className='text-md py-5 leading-8 text-gray-700'>As a Software Engineer at Amazon in NYC, I'm like a tech detective, always on the lookout for the next big problem to solve. When I'm not busy untangling code at one of the world's tech giants, you can find me diving headfirst into the startup world — because who needs sleep, right? Living in the city that never sleeps, I fit right in, coding by day, startup superhero by night. My motto? "Keep calm and code on... and maybe conquer the tech world one startup at a time." 🚀💻🌃</p>
          </div>

          <div className='text-5xl flex justify-center gap-16 py-3'>
            <AiFillGithub />
            <AiFillYoutube />
            <AiFillTwitterCircle />
          </div>

          <div>

          </div>

        </section>
        <body>

        </body>
      </main>
    </div>
  )
}

export default App;
